import React, { useEffect, useState } from "react";
import { Button } from "@material-ui/core";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";

const LockButton = (props: any) => {
  const { isLock, onChange } = props;
  const [lock, setLock] = useState(isLock);

  useEffect(() => {
    setLock(isLock);
  }, [isLock]);
  return (
    <Button
      startIcon={lock ? <LockIcon /> : <LockOpenIcon />}
      onClick={() => {
        onChange?.(!lock);
        setLock(!lock);
      }}
      {...props}
    >
      {props.text}
    </Button>
  );
};

export default LockButton;
